import React, { Component } from "react"; 

import { Link, Redirect } from "react-router-dom";

import { connect } from "react-redux";

import {
  updateProfile,
  forgotPwd,
  signOut,
  deleteProfile,
  deleteStripe,
} from "../store/actions/authActions";

import Logo from "../assets/images/logo.png";
import Menu from "../assets/svg/menu-light.svg";
import { withAlert } from "react-alert";

import MenuFunc from "./Menu";

import { Helmet } from "react-helmet";

class Account extends Component {
  constructor(props) {
    super(props);

    this.state = {
      menuToggled: false,
      password: "",
      weight: "",
      height: "",
      age: "",
      gender: "",
      id: props.auth.uid,
    };
  }

  setmenuoff = (wot) => {
    this.setState({ menuToggled: wot });
  };

  ff = (wot) => {
    this.setState({ menuToggled: wot });
  };

  handleSubmit = (e) => {
    e.preventDefault();
    this.props.updateProfile(this.state);
    // this.props.history.push("/");
  };

  handleChange = (e) => {
    this.setState({
      [e.target.id]: e.target.value,
    });
  };

  componentDidMount() {
    this.setState({ ...this.props.profile });
  }
  componentDidUpdate(previousProps, previousState) {
    if (previousProps.profile !== this.props.profile) {
      this.setState({ ...this.props.profile });
    }
  }

  render() {
    const { auth, profile, alert } = this.props;
    if (JSON.parse(localStorage.getItem('isPremium')) === true) {
        profile.isPremium = true;
    }
    if (!auth.uid) return <Redirect to="/" />;

    return (
      <div>
        <Helmet>
          <title>Settings</title>
          <meta
            name="description"
            content="BoxFit est l'application Web d'entraînement à domicile ultime
    avec plus de 390 exercices vidéo, 10 catégories d'entraînement différentes et
    des fonctionnalités premium telles que l'historique d'entraînement et le radar de poids."
          />

          <meta property="og:url" content="https://www.boxfit-fitness.com/account" />
          <meta property="og:title" content="BoxFit" />
          <meta
            property="og:description"
            content="BoxFit est l'application Web d'entraînement à domicile ultime
    avec plus de 390 exercices vidéo, 10 catégories d'entraînement différentes et
    des fonctionnalités premium telles que l'historique d'entraînement et le radar de poids."
          />
          <meta property="og:site_name" content="BoxFit" />
          <meta
            property="og:image"
            content="https://www.boxfit-fitness.com/images/sharer.png"
          />
          <meta property="og:type" content="profile" />
          <meta property="og:locale" content="en_US" />
        </Helmet>
        <div style={{ position: "relative" }}>
          <MenuFunc display={this.state.menuToggled} off={this.setmenuoff} />

          <div
            style={{
              zIndex: 999,
              position: "absolute",
              top: "15px",
              left: "20px",
            }}
          >
            <Link
              to={{
                pathname: "/",
                query: {
                  fromMenu: true,
                },
              }}
            >
              <img src={Logo} alt="logo" style={{ maxHeight: "45px" }}></img>
            </Link>
          </div>

          <div
            style={{
              position: "absolute",
              top: "25px",
              right: "22px",
              zIndex: 999,
            }}
            onClick={() => {
              this.setmenuoff(true);
            }}
          >
            <img src={Menu} alt="logo" style={{ maxHeight: "25px" }}></img>
          </div>
        </div>

        <div
          className="Screen"
          style={
            {
              /*height: "800px",
            width: "450px",
            borderRadius: "20px",
            boxShadow: "2px 2px 120px rgba(255, 255, 255, 0.15)",
            backgroundColor: "#000",*/
            }
          }
        >
          <div>
            <div style={{ height: "60px" }}></div>
            <div style={{ padding: "0px 20px 20px 20px" }}>
              <h2
                style={{
                  fontSize: "22px",
                  color: "#69C9D0",
                  borderRadius: "2px",
                }}
              >
                Account:
              </h2>
              <form onSubmit={this.handleSubmit}>
                <div className="wrappert">
                  <input
                    style={{
                      width: "100%",
                      height: "50px",
                      fontSize: "18px",
                      padding: "8px",
                      border: 0,
                      borderRadius: "4px",
                      color: "#000",
                    }}
                    type="text"
                    disabled
                    defaultValue={profile.email}
                  />
                </div>
                <div style={{ height: "20px" }}></div>

                <div className="wrappert">
                  <input
                    style={{
                      width: "100%",
                      height: "50px",
                      fontSize: "18px",
                      padding: "8px",
                      border: 0,
                      borderRadius: "4px",
                    }}
                    type="text"
                    placeholder="Entrez votre poids (facultatif)"
                    id="weight"
                    onChange={this.handleChange}
                    value={this.state.weight}
                  />
                </div>
                <div style={{ height: "20px" }}></div>

                <div className="wrappert">
                  <input
                    style={{
                      width: "100%",
                      height: "50px",
                      fontSize: "18px",
                      padding: "8px",
                      border: 0,
                      borderRadius: "4px",
                    }}
                    type="text"
                    placeholder="Entrez votre taille (facultatif)"
                    id="height"
                    onChange={this.handleChange}
                    value={this.state.height}
                  />
                </div>
                <div style={{ height: "20px" }}></div>

                <div className="wrappert">
                  <input
                    style={{
                      width: "100%",
                      height: "50px",
                      fontSize: "18px",
                      padding: "8px",
                      border: 0,
                      borderRadius: "4px",
                    }}
                    type="text"
                    placeholder="Entrez votre âge (optional)"
                    id="age"
                    onChange={this.handleChange}
                    value={this.state.age}
                  />
                </div>

                <div style={{ height: "20px" }}></div>

                <div className="wrappert">
                  <select
                    style={{
                      width: "100%",
                      height: "50px",
                      fontSize: "18px",
                      padding: "5px",
                    }}
                    id="gender"
                    onChange={this.handleChange}
                    value={this.state.gender}
                  >
                    <option value="none">Sélectionnez votre sexe</option>
                    <option value="female">Femme</option>
                    <option value="male">Homme</option>
                  </select>
                </div>

                <div style={{ height: "20px" }}></div>

                <button
                  style={{
                    fontSize: "18px",
                    background: "#EE1D52",
                    padding: "10px",
                    border: 0,
                    borderRadius: "4px",
                    fontWeight: "600",
                    width: "100%",
                    color: "white",
                  }}
                  /*onClick={() => {
                  this.setState({ finished: false });
                }}*/
                >
                  <span role="img" aria-label="like">
                    👉
                  </span>{" "}
                  Save changes
                </button>
              </form>
              <div style={{ height: "10px" }}></div>

              <h2
                style={{
                  fontSize: "22px",
                  color: "#69C9D0",
                  borderRadius: "2px",
                }}
              >
                Premium:
              </h2>

              {profile.isPremium && !profile.willbecancelled ? (
                <p
                  style={{
                    fontSize: "18px",
                    textAlign: "left",
                  }}
                >
                  Click{" "}
                  <strong
                    onClick={() => {
                      alert.show(
                        "Votre abonnement premium a été annulé !"
                      );
                      this.props.deleteStripe({
                        id: auth.uid,
                        subscription: profile.subscription,
                      });
                      setTimeout(() => {
                        window.location.reload(false);
                      }, 4000);
                    }}
                  >
                    here
                  </strong>{" "}
                  pour annuler souscription premium.
                </p>
              ) : profile.isPremium && profile.willbecancelled ? (
                <p
                  style={{
                    fontSize: "18px",
                    textAlign: "left",
                  }}
                >
                  Votre abonnement Premium a été annulé avec succès mais vous
                  peut encore en profiter jusqu'à la fin de la facturation en cours
                  période.
                </p>
              ) : (
                <p
                  style={{
                    fontSize: "18px",
                    textAlign: "left",
                  }}
                >
                  Click{" "}
                  <strong>
                    <Link style={{ color: "white" }} to="/upgrade">
                      here
                    </Link>
                  </strong>{" "}
                  to go premium.
                </p>
              )}

              <div style={{ height: "10px" }}></div>

              <h2
                style={{
                  fontSize: "22px",
                  color: "#69C9D0",
                  borderRadius: "2px",
                }}
              >
                Password Reset:
              </h2>

              <p
                style={{
                  fontSize: "18px",
                  textAlign: "left",
                }}
              >
                Click{" "}
                <strong
                  onClick={() => {
                    this.props.forgotPwd({ email: profile.email });
                    alert.show(
                      "Nous vous avons envoyé un lien pour réinitialiser votre mot de passe !"
                    );
                  }}
                >
                  here
                </strong>{" "}
                pour demander un lien de réinitialisation du mot de passe.
              </p>

              <div style={{ height: "10px" }}></div>
              <h2
                style={{
                  fontSize: "22px",
                  color: "#69C9D0",
                  borderRadius: "2px",
                }}
              >
                Log out:
              </h2>

              <p
                style={{
                  fontSize: "18px",
                  textAlign: "left",
                }}
              >
                Click{" "}
                <strong
                  onClick={() => {
                    this.props.signOut();
                  }}
                >
                  here
                </strong>{" "}
                pour vous déconnecter de votre compte.
              </p>

              <div style={{ height: "10px" }}></div>
              <h2
                style={{
                  fontSize: "22px",
                  color: "#69C9D0",
                  borderRadius: "2px",
                }}
              >
                Supprimer compte:
              </h2>

              <p
                style={{
                  fontSize: "18px",
                  textAlign: "left",
                }}
              >
                Click{" "}
                <strong
                  onClick={() => {
                    alert.show("Votre compte a été supprimé...");
                    this.props.deleteProfile(this.state);
                    this.props.signOut();
                  }}
                >
                  here
                </strong>{" "}
                pour supprimer définitivement votre compte.
              </p>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    auth: state.firebase.auth,
    profile: state.firebase.profile,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    updateProfile: (obj) => dispatch(updateProfile(obj)),
    forgotPwd: (obj) => dispatch(forgotPwd(obj)),
    deleteProfile: (obj) => dispatch(deleteProfile(obj)),
    deleteStripe: (obj) => dispatch(deleteStripe(obj)),
    signOut: () => dispatch(signOut()),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withAlert()(Account));
